import React, { Component } from 'react';


import { Button, Col, Container, Label, Row } from "reactstrap";

// Redux
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// actions
import { apiError, checkLogin, resetLoginState } from '../../store/actions';

// import images
import { Alert, InputAdornment, Stack, TextField } from '@mui/material';
import logoblack from "../../assets/images/cvs-logo.png";
import withRouter from '../../components/Common/withRouter';

class Login extends Component {
    constructor(props) {
        super(props);
        this.props.resetLoginState()
        this.state = { username: "", password: "" }
        // this.state = { username: "admin@themesdesign.in", password: "123456" }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit() {
        this.props.resetLoginState()
        const values = {
            email: this.state.username,
            password: this.state.password
        }
        this.props.checkLogin(values, this.props.router.navigate);
    }
    async componentDidMount() {
        document.body.classList.add("auth-body-bg");
    }

    componentWillUnmount() {
        document.body.classList.remove("auth-body-bg");
    }

    render() {
        return (
            <React.Fragment>
                <div>
                    <Container fluid className="p-0">
                        <Row className="g-0">
                            <Col lg={4}>
                                <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                                    <div className="w-100">
                                        <Row className="justify-content-center">
                                            <Col lg={9}>
                                                <div>
                                                    <div className="text-center">
                                                        <div>
                                                            <img src={logoblack} alt="" height="70" className="" />
                                                        </div>
                                                        <h4 className="font-size-17 mt-4">Welcome Back !</h4>
                                                        <p className="text-muted">Sign in to continue to CVSKL.</p>
                                                    </div>
                                                    {this.props.loginError && this.props.loginError ? <Alert severity="error">{this.props.loginError}</Alert> : null}
                                                    <div className="p-2 mt-2">


                                                        <div className=" mb-2">
                                                            <Stack flexDirection="column">
                                                                <Label htmlFor="username">Email</Label>
                                                                <TextField
                                                                    required
                                                                    value={this.state.username}
                                                                    variant="outlined"
                                                                    onChange={(e) => this.setState({ username: e.target.value })}
                                                                    InputProps={{
                                                                        startAdornment: <InputAdornment position="start" className='auth-icon'><i className="ri-user-2-line auti-custom-input?-icon"></i></InputAdornment>,
                                                                    }}
                                                                />
                                                            </Stack>

                                                        </div>
                                                        <div className=" mb-2">
                                                            <Stack flexDirection="column">
                                                                <Label htmlFor="userpassword">Password</Label>
                                                                <TextField
                                                                    required
                                                                    type='password'
                                                                    value={this.state.password}
                                                                    variant="outlined"
                                                                    onChange={(e) => this.setState({ password: e.target.value })}
                                                                    InputProps={{
                                                                        startAdornment: <InputAdornment position="start" className='auth-icon'><i className="ri-lock-2-line auti-custom-input-icon"></i></InputAdornment>,
                                                                    }}
                                                                />
                                                            </Stack>

                                                        </div>

                                                        {/* <div className="form-check">
                                                            <FormControlLabel required control={<Checkbox />} label="Remember me" />
                                                        </div> */}
                                                        <div className="mt-4 text-center">
                                                            <Button color="primary-button" className="w-md waves-effect waves-light" type="submit" onClick={this.handleSubmit}>Log In</Button>
                                                        </div>

                                                        <div className="mt-4 text-center">
                                                            <Link to="/reset-password" className="text-muted" onClick={(e)=>(this.props.resetLoginState())}><i className="mdi mdi-lock me-1"></i> Forgot your password?</Link>
                                                        </div>
                                                    </div>
                                                </div>

                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={8}>
                                <div className="authentication-bg">
                                    <div className="bg-overlay"></div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { loginError } = state.Login;
    return { loginError };
}

export default withRouter(connect(mapStatetoProps, { checkLogin, apiError, resetLoginState })(Login));